export function isCommissionShop(kind: number): boolean {
  return kind === 1;
}
